// extracted by mini-css-extract-plugin
export default {"root":"WMme2D4EuWVBu6eNbDrq","sticker":"nuxJfDCSB8FLdD_JK5Vm","free":"FkyS3gYHoUcea6E51tFj","disabled":"dbhxgRmCjKegNFLwBGNa","placeHolderShimmer":"w8H5UbvSxpfm34pQpxno"};